import 'focus-visible';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'jquery.cycle2';

import './lib/ls.bgset';
import Navbar from './components/Navbar';
import Slider from './components/Slider';
import ProjectFilter from './components/ProjectFilter';
import PreviewLink from './components/PreviewLink';

Navbar.init();
Slider.init();
ProjectFilter.init();
PreviewLink.init();
